import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Typography, Box } from '@mui/material';
import { HtmlRender } from 'components/elements';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function AppointmentDetailInstruction({ instructions }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  if (!instructions) return null;
  return (
    <Box className={classes.infoWrapper} data-testid="appointment-instructions">
      <Typography sx={{ fontWeight: 'bold' }} variant="h6" color="text" component="h6">
        {t('appointment_instructions')}
      </Typography>
      <Typography className={classes.instruction} variant="body1" color="text" component="p" data-testid="appointment-instructions-text">
        <HtmlRender data={instructions} htmlProfile />
      </Typography>
    </Box>
  );
}

AppointmentDetailInstruction.propTypes = {
  instructions: PropTypes.string,
};
AppointmentDetailInstruction.defaultProps = {
  instructions: null,
};
export default AppointmentDetailInstruction;
